var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.5C10 2.67157 9.32843 2 8.5 2C7.67157 2 7 2.67157 7 3.5H6C6 2.11929 7.11929 1 8.5 1C9.88071 1 11 2.11929 11 3.5H15.5C15.7761 3.5 16 3.72386 16 4C16 4.27614 15.7761 4.5 15.5 4.5H14.946L13.6499 15.7292C13.5335 16.7384 12.679 17.5 11.6631 17.5H5.33688C4.321 17.5 3.4665 16.7384 3.35006 15.7292L2.053 4.5H1.5C1.25454 4.5 1.05039 4.32312 1.00806 4.08988L1 4C1 3.72386 1.22386 3.5 1.5 3.5H10ZM13.938 4.5H3.061L4.34347 15.6146C4.40169 16.1192 4.82894 16.5 5.33688 16.5H11.6631C12.1711 16.5 12.5983 16.1192 12.6565 15.6146L13.938 4.5ZM7 7C7.24546 7 7.44961 7.15477 7.49194 7.35886L7.5 7.4375V13.5625C7.5 13.8041 7.27614 14 7 14C6.75454 14 6.55039 13.8452 6.50806 13.6411L6.5 13.5625V7.4375C6.5 7.19588 6.72386 7 7 7ZM10 7C10.2455 7 10.4496 7.15477 10.4919 7.35886L10.5 7.4375V13.5625C10.5 13.8041 10.2761 14 10 14C9.75454 14 9.55039 13.8452 9.50806 13.6411L9.5 13.5625V7.4375C9.5 7.19588 9.72386 7 10 7Z",
    fill: "#DFF6FF",
    stroke: "#DFF6FF",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelectIcon);
export default __webpack_public_path__ + "static/media/delectIcon.c5916804a379ac34ccd8447bd5bfb1eb.svg";
export { ForwardRef as ReactComponent };